
$_GP._.debounce = function (fn, wait) {

	wait = wait || 250;

	var timeout;
	return function () {
		const context = this;
		const args = arguments;

		var later = function () {
			timeout = null;
			fn.apply(context, args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
};
